import React, { useState } from 'react';
import { Card } from './ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      id: 'faq-1',
      question: 'Was kostet eine Wohnung zu streichen in Zürich?',
      answer: 'Die Kosten hängen von Größe, Zustand und Möblierung ab. Leere Wohnungen mit weißem Standardanstrich sind besonders günstig. Gerne senden wir Ihnen schnell ein Fixpreis-Angebot.'
    },
    {
      id: 'faq-2',
      question: 'Wie schnell bekommen wir ein Angebot?',
      answer: 'In vielen Fällen innerhalb kurzer Zeit per WhatsApp. Senden Sie uns einfach Fotos oder die m²-Angabe Ihrer Wohnung.'
    },
    {
      id: 'faq-3',
      question: 'Streichen Sie auch möblierte Wohnungen?',
      answer: 'Ja, auch möblierte Wohnungen sind möglich. Der Preis liegt wegen des höheren Aufwands meist etwas höher.'
    },
    {
      id: 'faq-4',
      question: 'Sind kleine Ausbesserungen inklusive?',
      answer: 'Ja, Bohrlöcher und kleine Risse können in der Regel mitgemacht werden.'
    },
    {
      id: 'faq-5',
      question: 'Welche Farbe wird verwendet?',
      answer: 'Wir verwenden hochwertige, hochdeckende weiße Innenfarbe. Auf Wunsch sind auch bessere Qualitätsstufen möglich.'
    },
    {
      id: 'faq-6',
      question: 'Bieten Sie auch Garantie auf Ihre Arbeit?',
      answer: 'Ja, wir garantieren für die Qualität unserer Arbeit. Bei Mängeln bessern wir kostenfrei nach.'
    },
    {
      id: 'faq-7',
      question: 'Wie lange dauert das Streichen einer Wohnung?',
      answer: 'Je nach Größe der Wohnung 1-3 Tage. Kleinere Wohnungen können oft an einem Tag fertiggestellt werden.'
    },
    {
      id: 'faq-8',
      question: 'Muss ich während der Arbeiten anwesend sein?',
      answer: 'Nein, Anwesenheit ist nicht zwingend erforderlich. Wichtig ist nur der Zugang zur Wohnung und eine kurze Abnahme nach Fertigstellung.'
    }
  ];

  const toggleFAQ = (id) => {
    setOpenIndex(openIndex === id ? null : id);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Häufig gestellte Fragen
            </h2>
            <p className="text-xl text-slate-600">
              Alles was Sie über unsere Malerarbeiten wissen müssen
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq) => (
              <Card
                key={faq.id}
                className="overflow-hidden border-2 hover:border-blue-200 transition-all duration-300"
              >
                <button
                  onClick={() => toggleFAQ(faq.id)}
                  className="w-full p-6 text-left flex justify-between items-center gap-4 hover:bg-slate-50 transition-colors"
                >
                  <span className="text-lg font-semibold text-slate-900 pr-4">
                    {faq.question}
                  </span>
                  {openIndex === faq.id ? (
                    <ChevronUp className="w-6 h-6 text-blue-600 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-6 h-6 text-slate-400 flex-shrink-0" />
                  )}
                </button>
                {openIndex === faq.id && (
                  <div className="px-6 pb-6 text-slate-600 text-lg leading-relaxed animate-accordion-down">
                    {faq.answer}
                  </div>
                )}
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;